import {Row, Col, Select, Form, Card} from "antd";
import {LangOptions, Translate, selectLang, updateLang} from "../../../../app/store/reducers/main/mainReducer";
import { useSelector, useDispatch } from 'react-redux';

const ChangeLanguage = () => {

  const lang = useSelector(selectLang);
  const t = Translate;
  const dispatch = useDispatch();

  const onChangeLang = async lang => {
      dispatch(updateLang(lang))
  }


  return (
    <>
      <Form>
            <Card>
          <Row className="d-flex justify-content-center" style={{height: "60vh"}}>
            <Col sm={6} className="w-100">
                <h4>Change Language</h4>
        <Form.Item>
              <Select onChange={onChangeLang} defaultValue={LangOptions[0]}>
                {LangOptions.map((langOption, i) => {
                  console.log(langOption);
                  return (
                    <Select.Option key={i} value={langOption}>
                      {langOption}
                    </Select.Option>
                  );
                })}
              </Select>
        </Form.Item>
            </Col>
          </Row>
            </Card>
      </Form>
    </>
  );
};

export default ChangeLanguage;
